import { authHeader,logout, handleResponse } from '../helpers';
import Vue from 'vue';


export const dislociranaenotaService = {
    load,loadAll,save,remove,loadPreteklaSezona,loadbymso
    
};

function load(sezona,predelovalecid) {
    const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };


    return fetch(`${Vue.prototype.$config.apiUrl}/predelava/predelovalec/dislociranaenota/?sezona=${sezona}&predelovalecid=${predelovalecid}`, requestOptions)
        .then(handleResponse)
        .then(dislociranaenota => {
            // login successful if there's a jwt token in the response
            
            return dislociranaenota;
        });
}

function loadPreteklaSezona(sezona,predelovalecid) {
    const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };


    return fetch(`${Vue.prototype.$config.apiUrl}/predelava/predelovalec/dislociranaenota/preteklasezona/?sezona=${sezona}&predelovalecid=${predelovalecid}`, requestOptions)
        .then(handleResponse)
        .then(dislociranaenota => {
            // login successful if there's a jwt token in the response
            
            return dislociranaenota;
        });
}


function loadbymso(mso,subjid,sezona) {
    const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };
    return fetch(`${Vue.prototype.$config.apiUrl}/predelava/predelovalec/dislociranaenota/mso/?mso=${mso}&subjid=${subjid}&sezona=${sezona}`, requestOptions)
        .then(handleResponse)
       
}

function save(dislociranaenota) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json',...authHeader()},
        body: JSON.stringify(dislociranaenota)
    };

    return fetch(`${Vue.prototype.$config.apiUrl}/predelava/predelovalec/dislociranaenota`, requestOptions).then(handleResponse);
}


function remove(dislociranaenota) {
    const requestOptions = {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json',...authHeader()},
        body: JSON.stringify(dislociranaenota)
    };

    return fetch(`${Vue.prototype.$config.apiUrl}/predelava/predelovalec/dislociranaenota`, requestOptions).then(handleResponse);
}

function loadAll(sezona){
  const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };


     return fetch(`${Vue.prototype.$config.apiUrl}/predelava/dislociraneenote/?sezona=${sezona}`, requestOptions)
        .then(handleResponse)
        .then(dislociranaenota => {
            // login successful if there's a jwt token in the response
            
            return dislociranaenota;
        });
}

function loadLastYear(gerk,status){
    //in tu lahko napišem pravila ali pa jih enostavno potegnem iz baze preko api-ja
    return fetch(`${Vue.prototype.$config.apiUrl}/predelava/predelovalec/dislociranaenota/?sezona=${sezona}&predelovalecid=${predelovalecid}`, requestOptions)
        .then(handleResponse)
        .then(dislociranaenota => {
            // login successful if there's a jwt token in the response
            
            return dislociranaenota;
        });

}
